module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"da":{"product-image-slider":{"pagination-label":"Fotoudvalg"}},"de":{"product-image-slider":{"pagination-label":"Fotoauswahl"}},"fr":{"product-image-slider":{"pagination-label":"Sélection de photos"}},"nl":{"product-image-slider":{"pagination-label":"Fotoselectie"}}}')
  delete Component.options._Ctor
}
